"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useState } from "react";
import Image from "next/image";

interface BannerImageData {
  attributes?: { url?: string };
}

interface BannerImage {
  data?: BannerImageData;
}

interface PillarCardProps {
  id: number;
  title: string;
  image: BannerImage;
  desicription: string;
}
interface LeadershipPillarsProps {
  block: {
    title: string;
    pillarsCard: PillarCardProps[];
  };
}
const LeadershipPillarsMobile: React.FC<LeadershipPillarsProps> = ({
  block,
}) => {
  // First card open by default
  const [currentIndex, setCurrentIndex] = useState(0);
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

  return (
    <div className="relative w-full lg:hidden block">
      <Swiper
        modules={[EffectFade, Navigation, Autoplay]}
        effect="fade"
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
        className="overflow-hidden h-full"
      >
        {block?.pillarsCard?.map((card, index) => (
          <SwiperSlide key={"slide" + index} className="CareerSliderHeight">
            <div
              className="h-full pillar-card-open overflow-hidden relative bg-[#E6F3FD] w-full p-[20px] before:content-[''] before:absolute before:inset-0 
              before:bg-[url('/images/leadership/card-shape-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bottom-[-2px]"
            >
              <div className="absolute top-0 right-0">
                <Image
                  src="/images/leadership/card-shape-1.svg"
                  alt="Leadership Pillars open"
                  width={130}
                  height={263}
                  className="object-cover w-[90px]  h-auto"
                />
              </div>

              <div className="relative inline-block mb-[94px]">
                <Image
                  src="/images/leadership/pillar-img-shape.png"
                  alt="Leadership Pillars shape"
                  width={116}
                  height={116}
                  className="object-cover w-[90px] h-[90px]"
                />
                {card?.image?.data?.attributes?.url && (
                  <Image
                    src={baseUrl + card?.image?.data?.attributes?.url}
                    alt="pillars-icon"
                    width={60}
                    height={60}
                    className="object-cover w-[40px] h-[40px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
                  />
                )}
              </div>

              <div className="relative z-1">
                <h4 className="text-[22px] leading-[28.8px] font-[700] text-[#040405] mb-[16px]">
                  {card?.title ?? ""}
                </h4>
                <p className="text-[18px] leading-[21.2px] font-[400] text-[#32343B] mb-0">
                  {card?.desicription ?? ""}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Progress Bar */}
      <div className="mt-[30px] flex justify-center items-center gap-2 px-12 py-6 sm:w-[67%] mx-auto relative">
        {block?.pillarsCard?.map((_, idx) => (
          <div
            key={idx}
            className={`p-0 relative rounded overflow-hidden ${
              currentIndex === idx
                ? "flex w-[128px] h-1 bg-background"
                : "flex-none w-[16px] h-1 bg-background"
            }`}
          >
            <span
              className={`absolute top-0 left-0 rounded h-1 ${
                currentIndex === idx
                  ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[3000ms] w-[128px]"
                  : "w-[16px]"
              }`}
            ></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeadershipPillarsMobile;
